import React from 'react';
import { observer, inject } from 'mobx-react';
import { Checkbox, Button } from 'react-bootstrap';
import Spinner from '../../../js/common/spinner';
import Alert from '../../../js/common/alert';
import Policy from './policy';

@inject('stores') @observer
export default class App extends React.Component {
    constructor(props) {
        super(props);
        this.handleOnClick = this.handleOnClick.bind(this);
        this.changeText = this.changeText.bind(this);
        this.agreePolicy = this.agreePolicy.bind(this);
        this.doScroll = this.doScroll.bind(this);
        this.props.stores.clearError();
    }

    agreePolicy(e) {
        this.props.stores.isAgreed = e.target.checked;
    }

    handleOnClick() {
        if (this.isValidate()) {
            this.props.history.push('step2');
        }
        return null;
    }

    doScroll(e) {
        const el = e.target;
        const pageBottom = el.scrollHeight;
        const scrollBottom = el.scrollTop + el.offsetHeight;

        if (scrollBottom >= pageBottom) {
            this.props.stores.isScrolldBottom = true;
        }
    }

    isValidate() {
        const phonePartten = '^\\d{2,5}-\\d{1,4}-\\d{4}$';
        const mobilePartten = '^\\d{3}-\\d{4}-\\d{4}$';
        const kanaPattern = '^[　ーァ-ヶ]+$';
        const mailPartten = "^[a-zA-Z0-9!$&*.=^`|~#%'+/?_{}-]+@([a-zA-Z0-9_-]+.)+[a-zA-Z]{2,4}$";
        const staffCodePartten = '^\\d{7}$';
        this.props.stores.clearError();
        if ((this.props.stores.lastNameKanji.length === 0) ||
            (this.props.stores.firstNameKanji.length === 0)) {
            this.props.stores.showErrorMessage('danger', 'お名前（姓名）を入力してください');
            return false;
        }
        if ((this.props.stores.lastNameKana.length === 0) ||
            (this.props.stores.firstNameKana.length === 0)) {
            this.props.stores.showErrorMessage('danger', 'お名前（フリガナ）を入力してください');
            return false;
        }
        if ((!this.props.stores.firstNameKana.match(kanaPattern)) ||
            (!this.props.stores.lastNameKana.match(kanaPattern))) {
            this.props.stores.showErrorMessage('danger', 'お名前（フリガナ）は40文字以内の全角カタカナで入力してください');
            return false;
        }
        if (this.props.stores.staffCode.length === 0) {
            this.props.stores.showErrorMessage('danger', 'スタッフコードを入力してください');
            return false;
        }
        else if (!this.props.stores.staffCode.match(staffCodePartten)) {
            this.props.stores.showErrorMessage('danger', 'スタッフコードは7桁の半角数字を入力してください');
            return false;
        }
        if (this.props.stores.phone.length !== 0 &&
            (!this.props.stores.phone.match(phonePartten) && !this.props.stores.phone.match(mobilePartten))) {
            this.props.stores.showErrorMessage('danger', '電話番号は14桁以内（半角数字ハイフン付き）で入力してください');
            return false;
        }
        if (this.props.stores.mail.length !== 0 && !this.props.stores.mail.match(mailPartten)) {
            this.props.stores.showErrorMessage('danger', 'メールアドレスを正しく入力してください。');
            return false;
        }
        if (this.props.stores.detail.length === 0) {
            this.props.stores.showErrorMessage('danger', '内容を入力してください');
            return false;
        }
        return true;
    }

    changeText(e) {
        this.props.stores.lastNameKanji = e.target.id === 'lastNameKanji' ? e.target.value : this.props.stores.lastNameKanji;
        this.props.stores.firstNameKanji = e.target.id === 'firstNameKanji' ? e.target.value : this.props.stores.firstNameKanji;
        this.props.stores.lastNameKana = e.target.id === 'lastNameKana' ? e.target.value : this.props.stores.lastNameKana;
        this.props.stores.firstNameKana = e.target.id === 'firstNameKana' ? e.target.value : this.props.stores.firstNameKana;
        this.props.stores.staffCode = e.target.id === 'staffCode' ? e.target.value : this.props.stores.staffCode;
        this.props.stores.phone = e.target.id === 'phone' ? e.target.value : this.props.stores.phone;
        this.props.stores.mail = e.target.id === 'mail' ? e.target.value : this.props.stores.mail;
        this.props.stores.detail = e.target.id === 'detail' ? e.target.value : this.props.stores.detail;
    }

    render() {
        const customLabel = window.TPNS_CatchTheHeartCustomLabel;
        const stores = this.props.stores;
        return (
            <div className="contentMain">
                <Spinner isLoading={stores.isLoading} />
                <div className="elem-status-step">
                    <ul className="step-1">
                        <li><span>0</span>1<span>.  内容入力</span></li>
                        <li><span>0</span>2<span>.  内容の確認</span></li>
                        <li><span>0</span>3<span>.  送信完了</span></li>
                    </ul>
                </div>
                <div className="form-horizontal">
                    <div className="form-inner">
                        <div className="fff">
                            <table className="confirm">
                                <tbody>
                                <tr>
                                    <td style={{ fontSize: '100%' }}>
                                        <div style={{display : 'inline'}} dangerouslySetInnerHTML={{__html:customLabel.labelAnnounce}} />
                                    </td>
                                </tr>
                                </tbody>
                            </table>
                            <h3>お電話でのご相談</h3>
                            <br />
                                <p>{customLabel.labelTel}</p>
                        </div>
                    </div>
                    <div className="form-inner">
                        <div className="fff">
                            <h3>WEBでのご相談</h3>
                        <Spinner isLoading={stores.isLoading} />
                            <fieldset>
                                <Alert
                                    ErrMode={stores.errMode}
                                    Content={stores.errMessage}
                                    Show={stores.showError}
                                />
                                <div className="form-group">
                                    <label className="col-md-2 col-xs-6 control-label" htmlFor="label" >お名前（姓名）</label>
                                    <div className="col-md-2 col-xs-6"><span className="label label-danger requiredLabel">必須</span></div>
                                    <div className="col-md-8 col-xs-12">
                                        <input
                                            id="lastNameKanji"
                                            className="form-control inputName"
                                            type="text"
                                            maxLength="20"
                                            value={stores.lastNameKanji}
                                            onChange={this.changeText}
                                            placeholder="姓"
                                        />
                                        <input
                                            id="firstNameKanji"
                                            className="form-control inputName"
                                            type="text"
                                            maxLength="20"
                                            value={stores.firstNameKanji}
                                            onChange={this.changeText}
                                            placeholder="名"
                                        />
                                    </div>
                                </div>
                                <div className="form-group">
                                    <label className="col-md-2 col-xs-6 control-label" htmlFor="label" >お名前（フリガナ）</label>
                                    <div className="col-md-2 col-xs-6"><span className="label label-danger requiredLabel">必須</span></div>
                                    <div className="col-md-8 col-xs-12">
                                        <input
                                            id="lastNameKana"
                                            className="form-control inputName"
                                            type="text"
                                            maxLength="20"
                                            value={stores.lastNameKana}
                                            onChange={this.changeText}
                                            placeholder="セイ"
                                        />
                                        <input
                                            id="firstNameKana"
                                            className="form-control inputName"
                                            type="text"
                                            maxLength="20"
                                            value={stores.firstNameKana}
                                            onChange={this.changeText}
                                            placeholder="メイ"
                                        />
                                    </div>
                                </div>
                                <div className="form-group">
                                    <label className="col-md-2 col-xs-6 control-label" htmlFor="label" >スタッフコード</label>
                                    <div className="col-md-2 col-xs-6"><span className="label label-danger requiredLabel">必須</span></div>
                                    <div className="col-md-8 col-xs-12">
                                        <input
                                            id="staffCode"
                                            className="form-control"
                                            type="text"
                                            maxLength="7"
                                            value={stores.staffCode}
                                            onChange={this.changeText}
                                            placeholder="1234567"
                                        />
                                    </div>
                                </div>
                                <div className="form-group">
                                    <label className="col-md-2 col-xs-6 control-label" htmlFor="label" >電話番号</label>
                                    <div className="col-md-2 col-xs-6"><span className="label label-danger inessential">任意</span></div>
                                    <div className="col-md-8 col-xs-12">
                                        <input
                                            id="phone"
                                            className="form-control"
                                            type="text"
                                            maxLength="14"
                                            value={stores.phone}
                                            onChange={this.changeText}
                                            placeholder="090-1234-5678"
                                        />
                                    </div>
                                </div>
                                <div className="form-group">
                                    <label className="col-md-2 col-xs-6 control-label" htmlFor="label" >メールアドレス</label>
                                    <div className="col-md-2 col-xs-6"><span className="label label-danger inessential">任意</span></div>
                                    <div className="col-md-8 col-xs-12">
                                        <input
                                            id="mail"
                                            className="form-control"
                                            type="text"
                                            value={stores.mail}
                                            onChange={this.changeText}
                                            placeholder="example@pasona.com"
                                        />
                                    </div>
                                </div>
                                <div className="form-group">
                                    <label className="col-md-2 col-xs-6 control-label" htmlFor="label" >内容</label>
                                    <div className="col-md-2 col-xs-6"><span className="label label-danger requiredLabel">必須</span></div>
                                    <div className="col-md-8 col-xs-12">
                                        <textarea
                                            id="detail"
                                            type="text"
                                            maxLength="3000"
                                            rows="10"
                                            value={stores.detail}
                                            onChange={this.changeText}
                                        />
                                    </div>
                                </div>
                                <Alert
                                    ErrMode={stores.errMode}
                                    Content={stores.errMessage}
                                    Show={stores.showError}
                                />
                            </fieldset>
                            <div className="elem-form-wrapper">
                                <div>
                                    <div className="form-inner">
                                        <p>下記個人情報の取り扱いについて、ご確認をお願い致します。</p>
                                        <div className="elem-policy" onScroll={this.doScroll}>
                                            <div className="elem-paragraph">
                                                <Policy />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="elem-form-btn-wrapper">
                                        <div className="row-fluid">
                                            <div className="col-md-offset-3 col-md-6">
                                                <Checkbox className="agreeCheck" disabled={!stores.isScrolldBottom} onChange={this.agreePolicy}>
                                                    最後まで読んで同意します。
                                                </Checkbox>
                                            </div>
                                            <div className="col-md-offset-3 col-md-6">
                                                <div className="command">
                                                    <Button className="btn-danger" style={{ background: '#8a0808' }} disabled={!stores.isAgreed} block onClick={this.handleOnClick}>確認画面へ</Button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="form-inner">
                        <div className="fff">
                            <p>※送信後、お問い合わせを受け付けた旨の自動返信メールをお送りします。<br />
                                届かない場合はメールアドレスの誤入力もしくはフィルタ設定による受信拒否になっている可能性がありますので<br />
                                フィルタ設定をご確認のうえ再度お問い合わせ下さい。<br /><br />
                                ※いただいたお問い合わせに対して、お電話にて回答を差し上げる場合がございますので、ご了承ください。</p>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}
